/* istanbul ignore file */
export default class Entity {
  id?: string;

  constructor(initialValues: Partial<Entity> = {}) {
    this.id = initialValues.id;
  }
}
